import PropTypes from "prop-types";
// material
import { Box, Select, MenuItem, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { alert } from "src/services/alert";
import Uploader from "./uploader/Uploader";

// ----------------------------------------------------------------------

PriceList.propTypes = {
  sx: PropTypes.object,
};

export default function PriceList({ defaultAttrName, defaultAttrs, defaultPriceList, onChange }) {
  const [attrs, setAttrs] = useState([]);
  const [attr, setAttr] = useState("");

  const [keys, setKeys] = useState([]);
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios
      .get("/store/attr/all")
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setAttrs(data);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    if (items || !defaultAttrName) return;
    setAttr(defaultAttrName);
    console.log("defaultAttrs", defaultAttrs);
    console.log(JSON.parse(defaultAttrs));
    setKeys(JSON.parse(defaultAttrs).map((a) => a.key));
    setItems(JSON.parse(defaultPriceList));
  }, []);

  function handleChange(e) {
    console.log(e.target.value);
    // return;
    const selectedAttr = attrs.find((a) => a.name === e.target.value);

    setAttr(selectedAttr.name);
    const items = getItems(selectedAttr.value);
    setItems(items);

    onChange({
      attrName: selectedAttr.name,
      attrs: selectedAttr.value,
      priceList: items,
    });
  }

  function getItems(value) {
    const attrList = JSON.parse(value);
    // console.log(value);

    const keys = [];
    const values = [];
    const items = [];
    const counts = [];

    for (let i = 0; i < attrList.length; i++) {
      const { key, value } = attrList[i];
      keys.push(key);
      values.push(value.split(","));
      counts.push(value.split(",").length);
    }

    setKeys(keys);

    const len = counts.length;
    const countIndices = Array(len).fill(0);

    for (; ; countIndices[len - 1]++) {
      for (let k = len - 1; k >= 0; k--) {
        if (countIndices[k] == counts[k]) {
          //当第k+1层循环已到最大值时
          if (k == 0) {
            return items;
          } else {
            countIndices[k] = 0;
            countIndices[k - 1]++;
          }
        }
      }

      // console.log(countIndices);
      const item = {};
      for (let i = 0; i < countIndices.length; i++) {
        item[keys[i]] = values[i][countIndices[i]];
      }
      const pair = countIndices.map((c, i) => values[i][c]).join("-");
      console.log(item, pair)
      items.push({
        pair,
        ...item,
        priceOriginal: 0,
        cost: 0,
        price: 0,
        stock: 0,
        points: 0,
      });
    }
  }

  function handleIptChange(idx, ki, val) {
    const _items = [...items];
    _items[idx][ki] = val;
    onChange({
      priceList: _items,
    });
  }

  return (
    <Box>
      <Select value={attr} onChange={handleChange}>
        {attrs.map((attr, i) => (
          <MenuItem value={attr.name} key={i}>
            {attr.name}
          </MenuItem>
        ))}
      </Select>

      {!!items && (
        <TableContainer variant="outlined" component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {keys.map((key, i) => (
                  <TableCell key={i}>{key}</TableCell>
                ))}
                <TableCell align="center">图片</TableCell>
                <TableCell align="center">原价</TableCell>
                <TableCell align="center">成本价</TableCell>
                <TableCell align="center">售价</TableCell>
                <TableCell align="center">库存</TableCell>
                <TableCell align="center">赠送积分</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row, i) => (
                <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  {keys.map((key, j) => (
                    <TableCell key={j}>{row[key]}</TableCell>
                  ))}
                  <TableCell align="right">
                    <Uploader images={row.image} onUploaded={(val) => handleIptChange(i, "image", val)} />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      label="原价"
                      type="number"
                      size="small"
                      sx={{ width: 120 }}
                      value={row.priceOriginal}
                      onChange={(e) => handleIptChange(i, "priceOriginal", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      label="成本价"
                      type="number"
                      size="small"
                      value={row.cost}
                      sx={{ width: 120 }}
                      onChange={(e) => handleIptChange(i, "cost", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      label="售价"
                      type="number"
                      size="small"
                      value={row.price}
                      sx={{ width: 120 }}
                      onChange={(e) => handleIptChange(i, "price", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      label="库存"
                      type="number"
                      size="small"
                      value={row.stock}
                      onChange={(e) => handleIptChange(i, "stock", e.target.value)}
                      sx={{ width: 120 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      label="赠送积分"
                      type="number"
                      size="small"
                      value={row.points}
                      onChange={(e) => handleIptChange(i, "points", e.target.value)}
                      sx={{ width: 120 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
